export const SUPPORT_EMAIL = 'partnerops@goat.com';
